// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__j-VRK","title":"InfoRow_title__1tIa4"};